import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AdrDto, AdrPersonnelDto, CommunityDto } from '@cradua/data';

@Component({
  selector: 'cradua-adrpersonnel',
  templateUrl: './adrpersonnel.component.html',
  styleUrls: ['./adrpersonnel.component.scss']
})
export class AdrpersonnelComponent implements OnInit {

  adrPersonnelForm: FormGroup;
  @Input() selectedSuitProgresss: AdrDto;
  @Input() communitiess: CommunityDto[];
  isToggle = false;
  listView = false;
  gridView = true;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.adrPersonnelForm = this.fb.group({
      AdrId: [''],
      PersonnelName: [''],
      CommunityId: [''],
      Address: [''],
      Phone	: [''],
      RolePlayed: [''],
      id: ['']
    });   
    if(this.selectedSuitProgresss?.adrPersonnels != null && this.selectedSuitProgresss?.adrPersonnels.length) {
      this.setAdrProgresss(this.selectedSuitProgresss?.adrPersonnels);
    }      
  }

  setAdrProgresss(personnels: AdrPersonnelDto[]) {
    personnels.forEach(value => {
      this.adrPersonnelForm.patchValue({
        AdrId: value.AdrId,
        PersonnelName: value.PersonnelName,
        CommunityId: value.CommunityId,
        Address: value.Address,
        Phone: value.Phone,
        RolePlayed: value.RolePlayed,
        id: value.id
      });
     });
   }

   getCommunity(id) {
    return this.communitiess.find(com => com.id === id);
   }

   onList() {
    this.listView = true;
    this.gridView = false;
  }

  onGrid() {
    this.gridView = true;
    this.listView = false;
  }
}
